<elcia-dialog
  (onAction)="confirm()"
  (onClose)="onClose.emit()"
  [size]="'medium'"
  [title]="'invoice.select-timesheets' | translate"
>
  @if (isLoading()) {
    <elcia-loader/>
  } @else if (availableTimesheets().length === 0) {
    <p class="text-center py-4 text-surface-400 text-sm italic">{{ 'invoice.no-timesheets' | translate }}</p>
  } @else {
    <p-table
      (selectionChange)="onSelectionChange($event)"
      [scrollable]="true"
      [selection]="selectedTimesheets()"
      [size]="'small'"
      [value]="availableTimesheets()"
      dataKey="id"
      scrollHeight="300px"
      selectionMode="multiple"
    >
      <ng-template #header>
        <tr>
          <th style="width: 3rem">
            <p-tableHeaderCheckbox/>
          </th>
          <th>{{ 'timesheet.date' | translate }}</th>
          <th>{{ 'timesheet.subject' | translate }}</th>
          <th>{{ 'timesheet.duration' | translate }}</th>
          <th>{{ 'timesheet.created-by' | translate }}</th>
          <th>{{ 'timesheet.state' | translate }}</th>
        </tr>
      </ng-template>
      <ng-template #body let-ts>
        <tr [class.opacity-50]="isDisabled(ts)">
          <td>
            <p-tableCheckbox [disabled]="isDisabled(ts)" [value]="ts"/>
          </td>
          <td>{{ ts.date | date:'dd/MM/yyyy' }}</td>
          <td>{{ ts.subject }}</td>
          <td>{{ ts.billableDurationInSeconds | duration }}</td>
          <td>{{ ts.createdBy?.fullName }}</td>
          <td>
            <elcia-timesheet-state-badge [state]="ts.billingTimesheetState"/>
          </td>
        </tr>
      </ng-template>
    </p-table>
  }
</elcia-dialog>
